import { GalleryConfig } from "@energylab/shared-components/constants/config/galleryConfig";

export const galleryConfig: GalleryConfig = {
    maxLoadingItems: 5,
    types: ["generic"]
};
